export default __webpack_public_path__ + "static/media/pangrams.8985a156.png";